'use client'

import { useState, useCallback, useEffect } from 'react'

import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import PickUpParcelModal from '../PickUpParcelModal'

const PickUpParcelLink = () => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true)
  }, [setIsModalOpen])

  const handleModalClose = () => setIsModalOpen(false)

  useEffect(() => {
    const handlePickupParcelLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.PickUpParcelLink)) return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handlePickupParcelLinkClick)

    return () => document.body.removeEventListener('click', handlePickupParcelLinkClick)
  }, [handleModalOpen])

  if (!transactionId) return null

  return (
    <PickUpParcelModal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      transactionId={transactionId}
    />
  )
}

export default PickUpParcelLink
